import { FleetManagementPermissions } from "../types/FleetManagement.types";
import { VehiclePermissionCheckAffectedBody } from "../types/VehiclePermissions.types";

type PermissionsLike =
  | FleetManagementPermissions
  | { companyIds?: string[]; costCenterUnitIds?: string[]; userIds?: string[] };

function toIdStrings(objects: { id?: string }[] | undefined, ids: string[] | undefined): string[] {
  if (Array.isArray(ids)) return ids.filter((id): id is string => typeof id === "string");
  if (Array.isArray(objects))
    return objects
      .map(o => o.id)
      .filter((id): id is string => typeof id === "string" && !Number.isNaN(Number(id)));
  return [];
}

/**
 * Builds the request body for POST /fleet/vehicles/:id/permissions/check-affected
 * from frontend permissions (either object shape companies/costCenterUnits/users or id arrays companyIds/costCenterUnitIds/userIds).
 * Maps to backend shape (companies, costCenterUnits, users as string[]).
 */
export function buildCheckAffectedBody(
  fleetPermissions: PermissionsLike
): VehiclePermissionCheckAffectedBody {
  const perms = fleetPermissions as Record<string, unknown>;
  const companies = toIdStrings(
    perms.companies as { id?: string }[] | undefined,
    perms.companyIds as string[] | undefined
  );
  const costCenters = toIdStrings(
    perms.costCenterUnits as { id?: string }[] | undefined,
    perms.costCenterUnitIds as string[] | undefined
  );
  const users = toIdStrings(
    perms.users as { id?: string }[] | undefined,
    perms.userIds as string[] | undefined
  );

  return {
    permissions: [
      {
        companies,
        costCenterUnits: costCenters,
        users,
        enforcedUserIds: []
      }
    ]
  };
}
